import { render } from "./pingjiList.vue?vue&type=template&id=38ee33ec&scoped=true"
import script from "./pingjiList.vue?vue&type=script&lang=js"
export * from "./pingjiList.vue?vue&type=script&lang=js"

import "./pingjiList.vue?vue&type=style&index=0&id=38ee33ec&scoped=true&lang=less"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ee33ec"]])

export default __exports__